import { render } from "./ErrNotFound.vue?vue&type=template&id=0869f4a5"
import script from "./ErrNotFound.vue?vue&type=script&lang=js"
export * from "./ErrNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__